import PropTypes from 'prop-types';
import React from 'react';
import {
	BoxArrowUpRight,
	ClockHistory,
	Telephone,
} from 'react-bootstrap-icons';

import useItemButton from '../../hooks/use_item_button';
import useProduct from '../../hooks/use_product';
import useTranslation from '../../hooks/use_translation';
import { createEvent } from '../../utils/tracking';
import Link from '../framework/link';
import AffiliateBrand from '../shop/affiliate_brand';
import ItemButton from '../shop/item-button';
import ItemButtonProduct from '../shop/item-button-product';
import ItemButtonSlim from '../shop/item-button-slim';

const ProductShopButton = ({
	onAddToCart,
	product_id,
	tracking,
	variant = 'default',
}) => {
	const { items: products } = useProduct({
		include_products: [product_id],
	});
	const { t } = useTranslation('component_product_shop_button');
	const { handleAction, inCart, isLoading } = useItemButton({
		onAddToCart,
		product_id,
		tracking,
	});

	const handleTracking = ({ id, text, type }) => {
		createEvent('button_click', {
			id,
			text,
			type,
		});
	};

	const variants = {
		default: {
			Component: ItemButton,
			buttonClassName: '',
			comingClassName: 'btn btn-dark text-white rounded-pill btn-shop',
		},
		product_item: {
			Component: ItemButtonProduct,
			buttonClassName: '',
			comingClassName: 'btn btn-dark text-white rounded-pill btn-shop',
		},
		slim: {
			Component: ItemButtonSlim,
			buttonClassName: '',
			comingClassName: 'btn btn-mustard xxs text-dark rounded-pill px-2 btn-sm',
		},
	};

	if (!variant || !variants[variant]?.Component) return <></>;
	const ItemButtonComponent = variants[variant]?.Component;

	const product = products[0];
	if (!product) return <></>;

	const product_brand_variant =
		product?.product_brand?.product_brand_variants[0];

	const component = (
		<div>
			{product?.product_variant?.state === 'affiliate' &&
				product?.status == 'active' &&
				product?.product_settings?.url_affiliate && (
					<Link
						className="btn rounded-pill btn-shop btn-accent text-white py-2 px-2"
						onClick={() =>
							handleTracking({
								id: product_id,
								text: product?.product_variant?.title,
								type: 'affiliate_shop_button',
							})
						}
						target="_blank"
						to={product?.product_settings?.url_affiliate}
					>
						<div className="d-flex align-items-center justify-content-between">
							<AffiliateBrand
								product_brand_id={product?.product_brand?.product_brand_id}
							/>
							{t('t5')} {product_brand_variant?.title}
							<BoxArrowUpRight className="me-3" />
						</div>
					</Link>
				)}
			{product?.product_variant?.state == 'archived' && (
				<span className="btn bg-white text-dark rounded-2 btn-shop">
					{t('t3')}
				</span>
			)}
			{product?.product_variant?.state === 'bookable' &&
				product?.status == 'active' && (
					<Link
						className={`btn btn-dark ${variant === ('slim' || 'list') ? 'btn-circle icon-container-lg' : 'text-white rounded-2 btn-shop'}`}
						size="xs"
						to={'/boka/'}
						variant="accent"
					>
						{variant === ('slim' || 'list') ? (
							<Telephone className="p-1" />
						) : (
							t('t1')
						)}
					</Link>
				)}
			{product?.product_variant?.state === 'coming' &&
				product?.status == 'active' && (
					<span
						className={`btn btn-light ${variant === ('slim' || 'list') ? 'btn-circle icon-container-lg' : ' rounded-2 btn-shop'}`}
					>
						{variant === ('slim' || 'list') ? (
							<ClockHistory className="p-1" />
						) : (
							t('t2')
						)}
					</span>
				)}
			{product?.product_variant?.state === 'contact' &&
				product?.status == 'active' && (
					<Link
						className={`btn btn-dark ${variant === ('slim' || 'list') ? 'btn-circle icon-container-lg' : 'text-white rounded-2 btn-shop'}`}
						to={'/foretagshalsovard/kontakt/'}
					>
						{variant === ('slim' || 'list') ? (
							<Telephone className="p-1" />
						) : (
							t('t4')
						)}
					</Link>
				)}
			{product?.product_variant?.state === 'orderable' &&
				product?.status == 'active' && (
					<span className="clickable-ignore">
						<div className="d-flex align-items-center">
							<ItemButtonComponent
								handleAction={handleAction}
								inCart={inCart}
								isLoading={isLoading}
								product_id={product_id}
							/>
						</div>
					</span>
				)}

			{variant === 'product_item' &&
				product?.product_variant?.state === 'orderable' && (
					<>
						<button
							className="d-block w-100 mt-3 btn btn-link"
							data-bs-target="#add-more-modal"
							data-bs-toggle="modal"
							onClick={() =>
								handleTracking({
									id: product_id,
									text: product?.product_variant?.title,
									type: 'add_more_button',
								})
							}
							type="button"
						>
							{t('t6')}
						</button>
					</>
				)}
		</div>
	);
	return <>{component}</>;
};

ProductShopButton.propTypes = {
	currency: PropTypes.object,
	markers: PropTypes.array,
	onAddToCart: PropTypes.func,
	price: PropTypes.string,
	product_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	product_variant_id: PropTypes.number,
	size: PropTypes.string,
	slug: PropTypes.string,
	status: PropTypes.string,
	title: PropTypes.string,
	tracking: PropTypes.object,
	variant: PropTypes.string,
};

export default ProductShopButton;
